<template>
            <v-col sm="6">
          <v-card class="mx-auto" max-width="400">
            <v-img class="white--text align-end" height="200px" src="https://cdn.vuetifyjs.com/images/cards/docks.jpg">
              <v-card-title style="color: white">Vikash Kumar</v-card-title>
            </v-img>

            <v-card-subtitle class="text-center">
              <b>Full Stack Developer</b>
            </v-card-subtitle>

            <v-card-text class="text--primary">
              <v-row>
                <v-col xs="6">
                  <v-icon small class="mr-2">mdi-phone</v-icon>
                  <b>Mobile </b>
                </v-col>
                <v-col xs="6" class="text-right">7004987522</v-col>
              </v-row>
              <v-row>
                <v-col xs="6">
                  <v-icon small class="mr-2">mdi-email</v-icon>
                  <b>Email </b>
                </v-col>
                <v-col xs="6" class="text-right">vikash1998bscc@gmail.com</v-col>
              </v-row>
              <v-row>
                <v-col xs="6">
                  <v-icon small class="mr-2">mdi-map-marker</v-icon>
                  <b>Location </b>
                  </v-col>
                <v-col xs="6" class="text-right">Siwan, Bihar (IN-841413)</v-col>
              </v-row>
            </v-card-text>

            <v-card-actions class="mx-auto">
              <v-btn text icon color="blue darken-2" v-bind:href="linkedin" target="_blank">
                <v-icon>mdi-linkedin</v-icon>
              </v-btn>
              <v-btn text icon color="blue darken-2" v-bind:href="github" target="_blank">
                <v-icon>mdi-github</v-icon>
              </v-btn>
              <v-btn text icon color="blue darken-2" v-bind:href="linkedin" target="_blank">
                <v-icon>mdi-facebook</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
</template>

<script>
export default {
    data: () => ({
      linkedin: "https://www.linkedin.com/in/vikash-kumar-a40860176",
      github: "https://github.com/vikash8507"
    }),
}
</script>

<style scoped>
* {
  color: #311B92
}
</style>